import { call, put, takeEvery, all } from 'redux-saga/effects';
import {
  fetchTeamsRoutine,
  createTeamRoutine,
  updateTeamRoutine,
  deleteTeamRoutine,
  getTeamUsersCountRoutine
} from './routines';
import { getTeams, createTeam, updateTeam, deleteTeam, getTeamMembersCount } from '../../services/teamService';
import { Routine } from 'redux-saga-routines';
import { successToast } from '../../common/helpers/toastrHelper';

function* getTeamsRequest() {
  try {
    const response = yield call(getTeams);
    yield put(fetchTeamsRoutine.success(response));
  } catch (error) {
    yield put(fetchTeamsRoutine.failure(error.message));
  }
}

function* watchGetTeamsRequest() {
  yield takeEvery(fetchTeamsRoutine.TRIGGER, getTeamsRequest);
}

function* createTeamRequest({ payload }: Routine<any>) {
  try {
    const team = yield call(createTeam, payload);
    yield put(createTeamRoutine.success(team));
  } catch (error) {
    yield put(createTeamRoutine.failure(error.message));
  }
}

function* watchCreateTeamRequest() {
  yield takeEvery(createTeamRoutine.TRIGGER, createTeamRequest);
}

function* updateTeamRequest({ payload }: Routine<any>) {
  try {
    const team = yield call(updateTeam, payload);
    yield put(updateTeamRoutine.success(team));
  } catch (error) {
    yield put(updateTeamRoutine.failure(error.message));
  }
}

function* watchUpdateTeamRequest() {
  yield takeEvery(updateTeamRoutine.TRIGGER, updateTeamRequest);
}

function* deleteTeamRequest({ payload }: Routine<any>) {
  try {
    yield call(deleteTeam, payload);
    yield put(deleteTeamRoutine.success(payload));
    yield call(successToast, 'Team successfully deleted', 'teamList.successDelete');
  } catch (error) {
    yield put(deleteTeamRoutine.failure(error.message));
  }
}

function* watchDeleteTeamRequest() {
  yield takeEvery(deleteTeamRoutine.TRIGGER, deleteTeamRequest);
}

function* getTeamUsersCountRequest({ payload }: Routine<any>) {
  try {
    const { usersCount } = yield call(getTeamMembersCount, payload);
    yield put(getTeamUsersCountRoutine.success(usersCount));
  } catch (error) {
    yield put(getTeamUsersCountRoutine.failure(error.message));
  }
}

function* watchGetTeamUsersCountRequest() {
  yield takeEvery(getTeamUsersCountRoutine.TRIGGER, getTeamUsersCountRequest);
}

export default function* assignmentFilterSaga() {
  yield all([
    watchGetTeamsRequest(),
    watchCreateTeamRequest(),
    watchUpdateTeamRequest(),
    watchDeleteTeamRequest(),
    watchGetTeamUsersCountRequest()
  ]);
}
